import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { registerPush } from '@/lib/push';

/**
 * Wires push-notification taps to the router so opening a notification lands
 * on the matching screen. No UI.
 */
const PushNavigationBridge = () => {
  const navigate = useNavigate();
  useEffect(() => {
    void registerPush((path) => navigate(path));
  }, [navigate]);
  return null;
};

export default PushNavigationBridge;
